var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"700px","padding-top":"2em"}},[_c('v-container',[_c('span',{staticClass:"org-title"},[_vm._v(" "+_vm._s(this.orgUid.company_name)+" Users ")]),_c('UserMgmt',{attrs:{"userAdmin":this.orgUid}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }